require.context("./static", false, /.{1,}/)
